import type { FunctionComponent } from "react";

import { Alert } from "@ppb/the-wall-web";
import { Stack } from "@ppb/the-wall-web/components/Stack/Stack";
import type { AlertsViewModel } from "@ppb/the-wall-common/types";

import styles from "./Alerts.web.css";

/**
 * A container for a set of alerts.
 *
 * TBD-owned copy of the-wall's `Alerts` wall. Adds a stable CSS-module class
 * hook on the wrapping `<ul>` so page objects can find the container after
 * upstream removed `Alerts.selectors.js` / `Alerts.modules.json`.
 */
export const Alerts: FunctionComponent<AlertsViewModel> = ({
  alerts = [],
  onAlertClick,
  onAlertUrlClick,
  onAlertClose,
}) => {
  if (alerts.length === 0) {
    return <></>;
  }

  return (
    <Stack as="ul" className={styles.alerts}>
      {alerts.map(
        (
          {
            id,
            type,
            message,
            items = [],
            detail,
            extraDetailInfo,
            url,
            hasClickableAction,
            dismissLabel,
            showCloseIcon,
          },
          index,
        ) => {
          const itemsMessage = items.join("").replace(/\s/, "").toLowerCase();
          const uniqueKey = `${type}:${message?.replace(/\s/, "").toLowerCase()}:${itemsMessage}:${index}`;

          return (
            <li className={styles.alert} key={uniqueKey}>
              <Alert
                id={id}
                type={type}
                message={message}
                items={items}
                detail={detail}
                onClick={onAlertClick}
                url={url}
                hasClickableAction={hasClickableAction}
                extraDetailInfo={extraDetailInfo}
                onUrlClick={onAlertUrlClick}
                showCloseIcon={showCloseIcon}
                dismissLabel={dismissLabel}
                onClose={onAlertClose}
              />
            </li>
          );
        },
      )}
    </Stack>
  );
};
